export default __webpack_public_path__ + "assets/singapore-flag.png";